import { tuple } from '../utils/types';

export const gemsProductIds = tuple(
  'buruburu_gems_50',
  'buruburu_gems_220',
  'buruburu_gems_600',
  'buruburu_gems_1250',
);

export type GemsProductId = typeof gemsProductIds[number];

export type ProductId = GemsProductId;

export const productIds: ProductId[] = [...gemsProductIds];

export type ProductRewardType = 'paidGems' | 'freeGems';
export type ProductReward = Partial<Record<ProductRewardType, number>>;

export const gemsRewardTable: Record<GemsProductId, ProductReward> = {
  buruburu_gems_50: {
    paidGems: 50,
  },
  buruburu_gems_220: {
    paidGems: 200,
    freeGems: 20,
  },
  buruburu_gems_600: {
    paidGems: 500,
    freeGems: 100,
  },
  buruburu_gems_1250: {
    paidGems: 1000,
    freeGems: 250,
  },
};

export const prices: Record<ProductId, number> =
  // USD
  {
    buruburu_gems_50: 99,
    buruburu_gems_220: 399,
    buruburu_gems_600: 999,
    buruburu_gems_1250: 1999,
  };

// Stripe price ids comes from the Stripe products dashboard
export const stripeTestPrices: Record<ProductId, string> = {
  buruburu_gems_50: 'price_1N1QyYGS1M9rbsMehBzTbrQj',
  buruburu_gems_220: 'price_1N1QyyGS1M9rbsMeINgkCbtA',
  buruburu_gems_600: 'price_1N1QzaGS1M9rbsMeimsQe232',
  buruburu_gems_1250: 'price_1N1QzuGS1M9rbsMeABRZAJOA',
};

// Stripe price ids comes from the Stripe products dashboard
export const stripeLivePrices: Record<ProductId, string> = {
  buruburu_gems_50: 'price_1N3KtXGS1M9rbsMesYInooLy',
  buruburu_gems_220: 'price_1N3Ku7GS1M9rbsMe4UARDwiB',
  buruburu_gems_600: 'price_1N3KuOGS1M9rbsMe1KlaZ4v3',
  buruburu_gems_1250: 'price_1N3KuiGS1M9rbsMe9xhtpz6U',
};
